import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import HomepageIcon from "../assets/images/icons/home.png";
import CricketIcon from "../assets/images/icons/cricket.png";
import SportsBookIcon from "../assets/images/icons/sportsbook.png";
import LiveBettingIcon from "../assets/images/icons/live-betting.png";
import CasinoIcon from "../assets/images/icons/seven.png";
import LiveCasinoIcon from "../assets/images/icons/live-casino.png";
import PromotionsIcon from "../assets/images/icons/promotions.png";
import AviatorImg from "../assets/images/icons/aviator-img.png";
import FaqIcon from "../assets/images/icons/question.png";
import RightArrowIcon from "../assets/images/icons/right-arrow-white.png";
import MobileIcon from "../assets/images/icons/mobile-phone.png";
import { useSelector } from "react-redux";
import LanguageChange from "../views/components/LanguageChange";

const headerPages = [
  "home",
  // "sports/betby?section=cricket",
  // "sports/betby?section=sportsBook",
  // "sports/betby?section=liveBetting",
  "atlas-lobby",
  "casino?category=gameLobby",
  "casino?category=overview",
  "promotion",
  "aviator",
];

const MobileMenu = () => {
  const { isAuth } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const isApk = localStorage.getItem("isApk") === "true";

  useEffect(() => {
    const matchedValue = headerPages.find((f) => {
      if (f?.includes("?")) {
        return (
          location.pathname?.indexOf(f?.split("?")[0]) > -1 &&
          location.search?.indexOf(f?.split("?")[1]) > -1
        );
      } else {
        return location?.pathname.includes(f);
      }
    });
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  return (
    <div className="mobile-menu d-md-none">
      <div className="menu-overlay"></div>
      <div className="menu">
        <div className="inner-wrapper">
          <div className="menu-list">
            <a
              href={isAuth ? "/home" : "/"}
              className={activePage == "home" ? "active" : ""}
            >
              <div className="img-box">
                <img src={HomepageIcon} alt="homepage" />
              </div>
              <span>Homepage</span>
            </a>
            <a
              href={"/atlas-lobby"}
              className={activePage == "atlas-lobby" ? "active" : ""}
            >
              <div className="img-box">
                <img src={CricketIcon} alt="cricket" />
              </div>
              <span>Cricket</span>
            </a>
            <a
              href="/atlas-lobby"
              className={activePage == "atlas-lobby" ? "active" : ""}
            >
              <div className="img-box">
                <img src={SportsBookIcon} alt="sportsbook" />
              </div>
              <span>SportsBook</span>
            </a>
            <a
              href="/atlas-lobby"
              className={activePage == "atlas-lobby" ? "active" : ""}
            >
              <div className="img-box">
                <img src={LiveBettingIcon} alt="live betting" />
              </div>
              <span>Live Betting</span>
            </a>
            <a
              onClick={() =>
                navigate("/casino?category=gameLobby", {
                  state: { activeCategory: "Game Lobby" },
                })
              }
              className={
                activePage == "casino?category=gameLobby" ? "active" : ""
              }
            >
              <div className="img-box">
                <img src={CasinoIcon} alt="casino" />
              </div>
              <span>Casino</span>
            </a>
            <a
              onClick={() =>
                navigate("/casino?category=overview", {
                  state: { activeCategory: "Overview" },
                })
              }
              className={
                activePage == "casino?category=overview" ? "active" : ""
              }
            >
              <div className="img-box">
                <img src={LiveCasinoIcon} alt="live casino" />
              </div>
              <span>Live Casino</span>
            </a>
            <a
              href="/promotion"
              className={activePage == "promotion" ? "active" : ""}
            >
              <div className="img-box">
                <img src={PromotionsIcon} alt="promotions" />
              </div>
              <span>Promotion</span>
            </a>
            <a
              onClick={() =>
                navigate("/casino/aggapspribe-aviator", {
                  state: { activeCategory: "Aviator" },
                })
              }
              className={activePage == "aviator" ? "aviator active" : "aviator"}
            >
              <img src={AviatorImg} alt="Aviator" />
            </a>
          </div>

          <div className="elements">
            <div className="app-block">
              <a href="javascript:void(0)">
                <img src={FaqIcon} alt="faq" className="left-icon" />
                <p className="title">FAQ</p>
                <img src={RightArrowIcon} alt="arrow right" />
              </a>
              {!isApk ? (
                <a
                  href="https://dl.dropbox.com/scl/fi/1qh1sjdgcd3z31b2xqrns/BetHeroz.apk?rlkey=tm4ue65wgqr1p44y0oy85l3ep&st=tt9hip3o&dl=0"
                  download={
                    "https://dl.dropbox.com/scl/fi/1qh1sjdgcd3z31b2xqrns/BetHeroz.apk?rlkey=tm4ue65wgqr1p44y0oy85l3ep&st=tt9hip3o&dl=0"
                  }
                  target="_blank"
                >
                  <img src={MobileIcon} alt="mobile" className="left-icon" />
                  <p className="title">Mobile App</p>
                  <img src={RightArrowIcon} alt="arrow right" />
                </a>
              ) : null}
              <a href="javascript:void(0)">
                <div className="language ">
                  <LanguageChange />
                </div>
              </a>
            </div>

            <div className="foot-menu-list">
              <a href="javascript:void(0)">Blog Betheroz</a>
              <a href="javascript:void(0)">About Us</a>
              <a href="/home">Responsible Gaming</a>
              <a href="javascript:void(0)">Betheroz Affiliates</a>
              <a href="/contact-us">Contact Us</a>
              <a href="/terms-conditions">Terms and Conditions</a>
              <a href="/home">Privacy Policy</a>
              <a href="/amlpolicyss">AML Policy</a>
              <a href="/Betting-rules">Betting Rules</a>
            </div>

            <div className="social-block"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
